const PHI_PATTERNS = [
  /\b\d{3}-\d{2}-\d{4}\b/,                    // SSN
  /\b\d{2}\/\d{2}\/\d{4}\b/,                   // DOB format MM/DD/YYYY
  /\bDOB\s*[:=]?\s*\d/i,                       // DOB label
  /\bSSN\s*[:=]?\s*\d/i,                       // SSN label
  /\bMRN\s*[:=]?\s*[\d#]/i,                    // MRN label
  /\bpatient\s+name\s*[:=]/i,                  // Patient name label
  /\bDate\s+of\s+Birth\s*[:=]/i,              // Date of Birth label
];

export interface PhiScanResult {
  hasPhiIndicators: boolean;
  flaggedFiles: string[];
}

export async function scanFilesForPhi(files: File[]): Promise<PhiScanResult> {
  const flaggedFiles: string[] = [];

  for (const file of files) {
    // Only scan text-readable files for v1
    if (!file.name.endsWith('.txt') && !file.name.endsWith('.csv')) continue;

    try {
      const text = await file.text();
      const hasPhi = PHI_PATTERNS.some(pattern => pattern.test(text));
      if (hasPhi) flaggedFiles.push(file.name);
    } catch {
      // Can't read file, skip scan
    }
  }

  return {
    hasPhiIndicators: flaggedFiles.length > 0,
    flaggedFiles,
  };
}
